export function formatPercetage(percent: number) {
    return Number(percent).toFixed(0) + "%"
}